var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"nofillpath"},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"8","stroke":"#3C4043","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }